<agpr-dialog-container
    id="digestSubscriberDialog"
    [heading]="'Briefings.manageDigestSubscriberDialog.heading'"
    [modal]="true"
    (close)="closeDialog()"
>
    <div class="agpr-digestSubscriberDialog-content">
        <div>
            <agpr-text-input
                [maxLength]="256"
                [placeholder]="'Briefings.manageDigestSubscriberDialog.filter.placeholder' | localize"
                [(ngModel)]="filterQuery"
                (ngModelChange)="filter()"
            ></agpr-text-input>
        </div>

        <div class="agpr-digestSubscriberDialog-container">
            <div
                class="agpr-digestSubscriberDialog-count"
                [innerHTML]="'Briefings.manageDigestSubscriberDialog.subscribers' | localize: { number: subscribers?.length || 0 }"
            ></div>
        </div>

        @if (!filteredSubscribers?.length) {
            <div class="agpr-digestSubscriberDialog-noContent">
                <agpr-message
                    [severity]="messageSeverityEnum.noContent"
                    icon="fa-regular fa-file-slash"
                >
                    {{ 'Briefings.manageDigestSubscriberDialog.subscribers.noSubscriber' | localize }}
                </agpr-message>
            </div>
        }

        <agpr-scroll-panel>
            <div class="agpr-digestSubscriberDialog-scrollContent">
                @for (subscriber of filteredSubscribers; track subscriber.email) {
                    <div class="agpr-digestSubscriberDialog-item">
                        <div class="agpr-digestSubscriberDialog-itemEmail">
                            {{ subscriber.email }}
                        </div>
                        <agpr-button
                            icon="fa-duotone fa-regular fa-square-x"
                            [style]="buttonType.contextMenu"
                            [agprTooltip]="'Briefings.manageDigestSubscriberDialog.removeSubscriber' | localize"
                            (click)="removeDigestSubscriber(subscriber)"
                        ></agpr-button>
                    </div>
                }
            </div>
        </agpr-scroll-panel>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            id="digestSubscriberDialog.cancelButton"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            id="digestSubscriberDialog.share"
            label="Briefings.manageDigestSubscriberDialog.shareDigest"
            [style]="buttonType.primary"
            (click)="share()"
        ></agpr-button>
        <agpr-button
            id="digestSubscriberDialog.done"
            label="Briefings.manageDigestSubscriberDialog.done"
            (click)="closeDialog()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
